export const ADD_ATTACHMENTS = 'ADD_ATTACHMENTS';
export const REMOVE_ATTACHMENTS = 'REMOVE_ATTACHMENTS';
export const REMOVE_FILE = 'REMOVE_FILE';



// WEBPACK FOOTER //
// ./src/Modules/UploadCashBackFile/UploadComponent/constants.js